import "./Frontline.module.css";
import Header from "@/reusable_sections/Header";
import DebattensCentrum from "./sections/DebattensCentrum";
import SkarpeIndlaeg from "./sections/SkarpeIndlaeg";
import EmneFokus from "./sections/EmneFokus";
import Footer from "@/reusable_sections/Footer";
export default function FrontlinePage() {
  return <div>
      <Header />
      <DebattensCentrum />
      <SkarpeIndlaeg />
      <EmneFokus />
      <Footer />
    </div>;
}